import { produce } from 'immer';
import { ANALYTICS_CREATE, ANALYTICS_METRICS_REQUEST, ANALYTICS_METRICS_SUCCESS, ANALYTICS_METRICS_FAILURE } from '../actions/analytics';
const defaultState = {
  metrics: [],
  period: 'today',
  interval: 'day',
  isLoading: false
};
const analytics = produce((state, action) => {
  switch (action.type) {
    case ANALYTICS_CREATE:
      state.implementation = action.payload.implementation;
      break;
    case ANALYTICS_METRICS_REQUEST:
      state.isLoading = true;
      state.period = action.payload.period;
      break;
    case ANALYTICS_METRICS_SUCCESS:
      state.metrics = action.payload.metrics;
      state.interval = action.payload.interval;
      state.isLoading = false;
      break;
    case ANALYTICS_METRICS_FAILURE:
      state.isLoading = false;
      break;
    default:
      return state;
  }
}, defaultState);
export function selectMetrics(state) {
  var _state$analytics;
  return (_state$analytics = state.analytics) === null || _state$analytics === void 0 ? void 0 : _state$analytics.metrics;
}
export function selectPeriod(state) {
  var _state$analytics2;
  return (_state$analytics2 = state.analytics) === null || _state$analytics2 === void 0 ? void 0 : _state$analytics2.period;
}
export function selectInterval(state) {
  var _state$analytics3;
  return (_state$analytics3 = state.analytics) === null || _state$analytics3 === void 0 ? void 0 : _state$analytics3.interval;
}
export function selectIsLoading(state) {
  var _state$analytics4;
  return (_state$analytics4 = state.analytics) === null || _state$analytics4 === void 0 ? void 0 : _state$analytics4.isLoading;
}
export default analytics;